/* eslint-disable @typescript-eslint/no-explicit-any */
import sanitizeHtml from 'sanitize-html'
import { cn } from '~/lib/utils'

const options = {
  allowedTags: [
    'em',
    'strong',
    'h2',
    'h3',
    'h4',
    'h5',
    'a',
    'p',
    'br',
    'ul',
    'ol',
    'li',
    'sup',
    'sub'
  ],
  allowedAttributes: {
    '*': ['*']
  },
  transformTags: {
    ul: sanitizeHtml.simpleTransform('ul', {
      // class: 'text-tag font-[450] md:text-base list-disc pl-4 space-y-1'
      class: 'list-group list-group-flush'
    }),
    li: sanitizeHtml.simpleTransform('li', {
      class: 'list-group-item'
    }),
    a: sanitizeHtml.simpleTransform('a', {
      class: 'cursor-pointer'
    })
  }
}

const HtmlBlock = ({ content, opt, className }: any) => {
  return (
    <div
      className={cn('space-y-xs max-w-[80ch]', className)}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(content, { ...options, ...opt })
      }}
    ></div>
  )
}

export default HtmlBlock
